import React from "react"
import { SvgIcon, SvgIconProps } from "@material-ui/core"

export default function Check(props: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <path d="M9.00002 16.2L4.80002 12L3.40002 13.4L9.00002 19L21 6.99998L19.6 5.59998L9.00002 16.2Z" />
    </SvgIcon>
  )
}
